import { render, staticRenderFns } from "./MdhealtForm.vue?vue&type=template&id=9bd912e0"
import script from "./MdhealtForm.vue?vue&type=script&lang=js"
export * from "./MdhealtForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports